import { defineMessages } from "react-intl";
const messages = defineMessages({
    switchUser: {
        id: "app.peekAdmin.switchUser.text",
        defaultMessage: "Switch User",
    },
    loggedAs: {
        id: "app.peekAdmin.loggedAs.text",
        defaultMessage: "— You're logged as <bold>{name}</bold> (<bold>{email}</bold>).",
    },
});
export default messages;
